import Router from "vue-router";

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
export default [
  {
    path: "/folder",
    name: "folder",
    component: resolve => require(["../views/Index"], resolve),
    meta: {
      allowPage: true // 添加该字段，表示进入这个路由是要验证的
    },
    children: [
      {
        path: "/recycle",
        meta: {
          allowPage: true // 添加该字段，表示进入这个路由是要验证的
        },
        component: resolve => require(["../views/Recycle"], resolve)
      },
      {
        path: "/materialcollection",
        meta: {
          allowPage: true // 添加该字段，表示进入这个路由是要验证的
        },
        component: resolve => require(["../views/MaterialCollection"], resolve)
      },
      {
        path: "/folder",
        meta: {
          allowPage: true // 添加该字段，表示进入这个路由是要验证的
        },
        component: resolve => require(["../views/Document"], resolve)
      },
      {
        path: "/document/:docName?",
        meta: {
          allowPage: true // 添加该字段，表示进入这个路由是要验证的
        },
        component: resolve => require(["../views/Document"], resolve)
      }
    ]
  },
  {
    path: "/",
    component: resolve => require(["../views/Content"], resolve),
    children: [
      {
        path: "/hot",
        name: "hotlist",
        component: resolve => require(["../views/Hot/HotList"], resolve),
        children: [
          {
            path: "/hotlist/hotarticle",
            name: "hotarticle",
            component: resolve => require(["../views/Hot/HotArticle"], resolve)
          },
          {
            path: "/hotlist/wxList",
            name: "wxList",
            component: resolve => require(["../views/Hot/WeiXinList"], resolve)
          },
          {
            path: "/hotlist/zhList",
            name: "zhList",
            component: resolve => require(["../views/Hot/ZhiHuList"], resolve)
          },
          {
            path: "/hotlist/tbList",
            name: "tbList",
            component: resolve => require(["../views/Hot/TieBaList"], resolve)
          },
          {
            path: "/hotlist/dbList",
            name: "dbList",
            component: resolve => require(["../views/Hot/DouBanList"], resolve)
          }
        ]
      },
      {
        path: "/article/:type/:guid",
        name: "article",
        component: resolve =>
          require(["../components/share/SucaiDetail"], resolve)
      },
      {
        path: "/collect/:type/detail/:id",
        name: "CollectDetail",
        component: resolve =>
          require(["../components/collection/CollectDetail"], resolve)
      },
      {
        path: "/material",
        name: "material",
        component: resolve => require(["../views/Sucai/SucaiSearch"], resolve)
      },
      {
        path: "/material/new/:title?",
        name: "materialNew",
        component: resolve => require(["../views/Sucai/SucaiSearch"], resolve)
      },
      {
        path: "/material/editor/:id",
        name: "materialEditor",
        component: resolve => require(["../views/Sucai/SucaiSearch"], resolve)
      },
      {
        // path: "/material/:type/:keyword/:searchType?",
        path: "/material/:type/:keyword/:tagkeyword?",
        name: "materialkeyword",
        component: resolve =>
          require(["../views/Sucai/SucaiSearchDeatil"], resolve)
      },
      {
        path: "/doc",
        name: "doc",
        component: resolve => require(["../views/doc/doc"], resolve)
      },
      //,
      // {
      //   path: "/solist",
      //   component: resolve => require(["../views/Sucai/SucaiSearchDeatil"], resolve),
      //   children: [{
      //     path: "/solist/:type/:keyword",
      //     name: "solist",
      //     component: resolve => require(["../views/Sucai/Paragraph"], resolve)
      //   }]
      // }
      {
        path: "/collect",
        name: "collect",
        component: resolve => require(["../views/Collection"], resolve)
      },
      {
        path: "/styles:userGiftType?:partyPack?:source?",
        name: "styles",
        component: resolve => require(["../views/Styles/Styles"], resolve)
      },
      {
        path: "",
        component: resolve => require(["../views/Styles/Styles"], resolve)
      }
      // ,
      // {
      //   path: "/image/:keyword?",
      //   name: "image",
      //   component: resolve => require(["../views/Image/Image"], resolve)
      // }

      // , {
      //   path: "/detail/:guid",
      //   name: "collect",
      //   component: resolve => require(["../views/Collection"], resolve)
      // }
    ]
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   meta: {
  //     allowPage: true // 添加该字段，表示进入这个路由是不需要验证的
  //   },
  //   component: resolve => require(["../components/dialogs/wycShowBox"], resolve)
  // },
  {
    path: "/login",
    name: "login",
    // meta: {
    //   allowPage: true, // 添加该字段，表示进入这个路由是不需要验证的
    // },
    component: resolve => require(["../views/Login"], resolve)
  },
  {
    path: "/phone",
    name: "phone",
    component: resolve =>
      require(["../components/styles/PhonePreview"], resolve)
  },
  {
    path: "/addReff",
    name: "addReff",
    component: resolve => require(["../views/addReff"], resolve)
  },
  {
    path: "*",
    redirect: "/"
  }
];
